module.exports = "https://cdn-shared.mathletics.com/teacher-modules/course-assign/39/assets/images/afc6425418a948a9b2d714c8e0d5ed76.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/icons/icon_plus.svg
// module id = unWD
// module chunks = 0